// @api/Dealers/DealersService.ts
import { axiosPrivate } from '@api/ApiHelper/axiosPrivate';
import axios from 'axios';
class DealersService {
  getDealersList = async (): Promise<any[]> => {
    try {
      const response = await axiosPrivate.get('/dealers/getList');
      if (response.status === 200 && response.data?.data) {
        return response.data.data;
      } else {
        throw new Error(response.data?.message || 'Error fetching dealers');
      }
    } catch (error) {
      console.error('DealersService.getDealersList:', error);
      throw error;
    }
  };

  getDealerById = async (id: string): Promise<any> => {
    try {
      const response = await axiosPrivate.get(`/dealers/${id}/getInfo`);
      if (response.status === 200 && response.data?.data) {
        return response.data.data;
      } else {
        throw new Error(response.data?.message || 'Error fetching dealer info');
      }
    } catch (error) {
      console.error(`DealersService.getDealerById (${id}):`, error);
      throw error;
    }
  };

  loginUser = async (usernameOrEmail: string, password: string): Promise<any> => {
    try {
      const response = await axiosPrivate.post('/login', {
        usernameOrEmail,
        password
      });

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error(response.data?.message || 'Login failed');
      }
    } catch (error) {
      console.error('DealersService.loginUser:', error);
      throw error;
    }
  };

  
  createOrder = async (order: any): Promise<any> => {
    try {
      const response = await axiosPrivate.post('/orders/createOrder', {
        order
      });
  
      if (response.status === 200 && response.data?.data) {
        return response.data.data; 
      } else {
        throw new Error(response.data?.message || 'Error creating order');
      }
    } catch (error) {
      console.error('DealersService.createOrder:', error);
      throw error;
    }
  };
  


login = async (email:any, password:any): Promise<any> => {
  try {
    const response = await axios.post('https://us-central1-spa-cover-system.cloudfunctions.net/api/login', {
      email,
      password
    });

    const { token, user } = response.data;

   
    localStorage.setItem('token', token);

    console.log("Usuario logueado:", user);
    return user;
  } catch (error) {
    console.error("Error en login:");
    localStorage.setItem('token', '');
    return null;
  }
}

getAttributes = async (): Promise<any[]> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Token no encontrado');

    const response = await axios.get(
      'https://us-central1-spa-cover-system.cloudfunctions.net/api/attributes',
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.status === 200 && Array.isArray(response.data)) {
      return response.data;
    } else {
      throw new Error(response.data?.message || 'Error fetching attributes');
    }
  } catch (error) {
    console.error('DealersService.getAttributes:', error);
    return [];
  }
};

}
export default new DealersService();

